export enum AppActionTypes {
  SET_ERROR = 'SET_ERROR',
  CLEAN_ERROR = 'CLEAN_ERROR',
}

export enum AddressActionTypes {
  FETCH_SUCCESS = 'FETCH_ADDRESS_SUCCESS',
}

export enum AuthActionTypes {
  LIST_ROLES_SUCCESS = 'LIST_ROLES_SUCCESS',
  LOGIN_ERROR = 'LOGIN_ERROR',
  SET_LOADING = 'SET_LOGIN_LOADING',
}

export enum ClientActionTypes {
  LIST_SUCCESS = 'LIST_CLIENTS_SUCCESS',
  LIST_ALL_SUCCESS = 'LIST_ALL_CLIENTS_SUCCESS',
  SET_LOADING = 'SET_CLIENTS_LOADING',
  RESET = 'RESET_CLIENTS',
}

export enum CustomerActionTypes {
  FETCH_SUCCESS = 'FETCH_CUSTOMER_SUCCESS',
}

export enum EventActionTypes {
  LIST_SUCCESS = 'LIST_EVENTS_SUCCESS',
  LIST_ALL_SUCCESS = 'LIST_ALL_EVENTS_SUCCESS',
  RESET = 'RESET_EVENTS',
}

export enum ResourceActionTypes {
  LIST_SUCCESS = 'LIST_RESOURCES_SUCCESS',
  LIST_ALL_SUCCESS = 'LIST_ALL_RESOURCES_SUCCESS',
  RESET = 'RESET_RESOURCES',
}

export enum SessionActionTypes {
  FETCH_SUCCESS = 'FETCH_SESSION_SUCCESS',
  LIST_SUCCESS = 'LIST_SESSIONS_SUCCESS',
  SET_LOADING = 'SET_SESSIONS_LOADING',
  RESET = 'RESET_SESSIONS',
}

export enum StaffActionTypes {
  LIST_SUCCESS = 'LIST_STAFF_SUCCESS',
  LIST_ALL_SUCCESS = 'LIST_ALL_STAFF_SUCCESS',
  RESET = 'RESET_STAFF',
}
